const HelpCircleIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 21'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10 3.00001C5.85787 3.00001 2.50001 6.35787 2.50001 10.5C2.50001 14.6421 5.85787 18 10 18C14.1421 18 17.5 14.6421 17.5 10.5C17.5 6.35787 14.1421 3.00001 10 3.00001ZM0.833344 10.5C0.833344 5.4374 4.9374 1.33334 10 1.33334C15.0626 1.33334 19.1667 5.4374 19.1667 10.5C19.1667 15.5626 15.0626 19.6667 10 19.6667C4.9374 19.6667 0.833344 15.5626 0.833344 10.5Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.2151 7.18694C9.82715 7.1204 9.42818 7.1933 9.08885 7.39273C8.74952 7.59216 8.49171 7.90525 8.3611 8.27654C8.20837 8.7107 7.73261 8.93885 7.29845 8.78612C6.86429 8.63339 6.63615 8.15763 6.78887 7.72347C7.0501 6.98088 7.56571 6.3547 8.24438 5.95584C8.92305 5.55698 9.72098 5.41118 10.4968 5.54426C11.2727 5.67735 11.9764 6.08072 12.4834 6.68295C12.9903 7.28505 13.2677 8.04707 13.2667 8.8341C13.2663 10.1094 12.3208 10.9516 11.6456 11.4017C11.2825 11.6437 10.9254 11.8217 10.6624 11.9386C10.5297 11.9976 10.4179 12.0423 10.3374 12.073C10.2971 12.0884 10.2644 12.1003 10.2406 12.1088L10.2116 12.1189L10.2024 12.122L10.1992 12.1231L10.1979 12.1236C10.1976 12.1236 10.1968 12.1239 9.93332 11.3333L10.1968 12.1239C9.76022 12.2695 9.28829 12.0335 9.14275 11.5969C8.99731 11.1605 9.23286 10.6889 9.66892 10.5431L9.66786 10.5434C9.66794 10.5434 9.66802 10.5434 9.66892 10.5431L9.68222 10.5384C9.69504 10.5338 9.71605 10.5262 9.74408 10.5155C9.80027 10.4941 9.88383 10.4608 9.98549 10.4156C10.1912 10.3242 10.4591 10.1896 10.7211 10.015C11.2957 9.63186 11.6 9.22429 11.6 8.83334L11.6 8.8321C11.6006 8.4385 11.4618 8.0574 11.2084 7.75628C10.9549 7.45517 10.603 7.25348 10.2151 7.18694Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.16666 14.6667C9.16666 14.2064 9.53975 13.8333 9.99999 13.8333H10.0083C10.4686 13.8333 10.8417 14.2064 10.8417 14.6667C10.8417 15.1269 10.4686 15.5 10.0083 15.5H9.99999C9.53975 15.5 9.16666 15.1269 9.16666 14.6667Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
};

export default HelpCircleIcon;
